type UserAvatarProps = {
  uri?: string | null;
  name?: string;
  size?: number;
};

export const UserAvatar = ({ uri, name, size = 48 }: UserAvatarProps) => {
  const initials =
    (name || "")
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0]?.toUpperCase())
      .join("") || "?";

  if (uri) {
    return (
      <img
        src={uri}
        alt={name || "User"}
        className="user-avatar"
        style={{ width: size, height: size }}
      />
    );
  }

  return (
    <div
      className="user-avatar user-avatar-fallback"
      style={{ width: size, height: size, fontSize: size * 0.35 }}
    >
      {initials}
    </div>
  );
};
